import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const RideNotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  gap: 12px;
  padding: 0 12px 12px 12px;
`;

export const AddNoteContainer = styled.div`
  width: 100% !important;
  background-color: ${colorTokens.background.default};
  border-radius: 0 0 12px 12px;
  padding: 6px;
  margin-top: auto;
`;
